import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';

export enum TrackAuctionRegistrationSubmittedType {
    Auto = 'Auto',
    Bid = 'Bid',
    User = 'User',
}

type TrackAuctionRegistrationSubmittedPayload = TrackingPayload & {
    registrationType: TrackAuctionRegistrationSubmittedType;
};

export const trackAuctionRegistrationSubmittedAnalytics = (payload: TrackAuctionRegistrationSubmittedPayload) => {
    track(TrackingEvents.Registration.AuctionRegistrationSubmitted, payload);
};
